import React, { useState } from 'react';

interface IContactPanelContextState {
    queuesOpen: boolean;
    agentsOpen: boolean;
    realtimeOpen: boolean;
}

interface IContactPanelContextActions {
    setQueuesOpen(open: boolean):void;
    setAgentsOpen(open: boolean): void;
    setRealtimeOpen(open: boolean): void;
}

export const ContactPanelContext = React.createContext<IContactPanelContextState & IContactPanelContextActions>({} as any)


export const ContactPanelProvider: React.FC<{}> = ({ children }) => {

    const [queuesOpen, setQueuesOpen] = useState(false);
    const [agentsOpen, setAgentsOpen] = useState(false);
    const [realtimeOpen, setRealtimeOpen] = useState(false);    

    return (
        <ContactPanelContext.Provider value={{
            queuesOpen,
            agentsOpen,
            realtimeOpen,
            setQueuesOpen,
            setAgentsOpen,
            setRealtimeOpen
        }}>
            {children}
        </ContactPanelContext.Provider>
    )
}

